// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2113":"bd692778","2918":"bd692778","5446":"bd692778","8670":"bd692778","8942":"bd692778","9742":"bd692778"}[chunkId] + ".chunk.css";
};